<template>
    <div class="info animated slideInRight">
        <span class="close show" @click="closed"></span>
        <div class="logInfo">
            <span class="tit show">{{$t('lan.signyours')}}</span>
            <input class="inputNR click" @focus="focusfns" @blur="blurfns(1)" :class="isName ? 'wrong' : ''" value="" v-model="name" :placeholder=" nemeholder "/>
            <input class="inputNR" @focus="focusfns" @blur="blurfns(2)" type="password" :class="isPwd ? 'wrong' : ''" value="" v-model="pwd" :placeholder=" pwdholder " />
            <div class="fleft codeYz m2B">
            <span class="btnsub show fleft" @click="loginIn">{{$t('lan.logIn')}}</span>
            <!-- <p class="show cur wx fright f20" @click="wxLogin()">
                <img class="wx_img fleft m20R" src="https://static.lanniuzai.com/img/account/passport/weixin.png">
            </p> -->
            </div>
            <p class="js">
				<span class="fleft" @click="toPwd">{{$t('lan.forgotpwd')}}</span>
				<span class="fright" @click="toReg">{{$t('lan.noAccount')}}{{$t('lan.creatnew')}}</span>
			</p>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { Dialog } from 'vant';
Vue.use(Dialog);
export default {
    name: 'app',
    components: {
        
    },
    props:{

    },
    data(){
        return {
            lang: window.location.href.indexOf('bluejeanimages')>0 ? 1 : 0,
            name:'',
            pwd:'',
            isName:false,
            isPwd:false,
            nemeholder:this.$t('lan.logName'),
            pwdholder:this.$t('lan.password'),
        }
    },
    created() {
        
    },
    mounted(){

    },
    destroyed(){
    
    },
    methods:{
        closed(){
            this.$emit('closeED',true)
        },
        toReg(){
            this.$emit('closeType',2)
        },
        toPwd(){
            this.$emit('closeType',3);
        },
        wxLogin(){
            window.location="//www.lanniuzai.com/store-web/oauth2/login?providerCode=wechat" ;   
        },
        focusfns(){
            this.isName=false;
            this.isPwd=false;
        },
        blurfns(type){
            if(type==1){
                if(this.name==''){
                    this.isName=true;
                }else{
                    this.isName=false;
                }
            }else{
                if(this.pwd==''){
                    this.isPwd=true;
                }else{
                    this.isPwd=false;
                }
            }
        },
        //登录
        loginIn(){
			let _this = this;
            var regName=/^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z0-9-_])*$/;
            var name=this.name;
            var pwd=this.pwd;
            if(name==''){
                this.isName=true;
                return;
            }else{
                this.isName=false;
            }
            if(pwd==''){
                this.isPwd=true;
                return;
            }else{
                this.isPwd=false;
            }
            var data = {
                userName: unescape(this.name),       
                password: this.pwd 
            };
			this.$store.dispatch("Login",data).then(res => {
			    console.log('cccccccc');
				console.log(res);
			    if(res){
					this.$emit('closeED',true);
				}
			})
			.catch(() => {
			    this.loading = false;
			    //this.getCode();
			});
        }
    }
}
</script>
<style lang="scss" scoped>
    .info{
      width:750px;
      margin:0 auto;
      background: #fff;
      height:100%;
      position: fixed;
      top:0;
      left: 0;
      z-index: 2000;
      color:#4d4d4d;
    }
    .logInfo{
      width:670px;
      height:750px;
      position:absolute;
      top:50%;
      left:50%;
      margin:-375px 0 0 -335px;
      font-size:26px;
      img{
        width:283px;
        height:89px;
      }
      .logo{
        width:100%;
        height:100px;
        text-align: center;
        img{
          width:300px;
          height:90px;
        }
      }
      .tit{
        width:100%;
        line-height:170px;
        font-size:30px;
        text-align: center;
        border-bottom:solid 1px #cbcbcb;
      }
      .inputNR{
        width:630px;
        height:78px;
        line-height:78px;
        padding:30px 20px;
        margin-bottom:2px;
        border-bottom:solid 1px #cbcbcb;
      }
      .inputNR.click{
        border-bottom:solid 3px #00a8ff; 
      }

      .btnsub{
        width:670px;
        height:100px;
        line-height:100px;
        background:#0ca1ea;
        color:#fff;
        text-align: center;
        letter-spacing:8px;
        font-size:36px;
       
      }
      .js{
        font-size:22px;
        line-height:150px;
      }
      .codeYz{
        width:100%;
        height:100px;
        overflow: hidden;
        line-height:100px;
        margin-top:45px;
        .wx{
          width:100px;
        }
        .wx_img{
          width:100px;
          height:100px;
        }
      }
    }
    
</style>
